import { Link } from 'react-router';
import { RoadrunnerMark } from '../../components/illustrations';
import styles from './Landing.module.css';

const EMAIL = 'nicholas@daylayown.org';
const LINKEDIN = 'https://www.linkedin.com/in/nicholas-de-leon-3b5b6a9/';

/** Top bar for the public pages (landing, About). */
export function SiteHeader({ action }: { action: { label: string; href: string } }) {
  return (
    <header className={`${styles.wrap} ${styles.topbar}`}>
      <Link to="/" className={styles.brand}>
        <RoadrunnerMark size={36} />
        Roadrunner
      </Link>
      {action.href.startsWith('#') ? (
        <a href={action.href} className={styles.signInLink}>
          {action.label}
        </a>
      ) : (
        <Link to={action.href} className={styles.signInLink}>
          {action.label}
        </Link>
      )}
    </header>
  );
}

/** Who made this and how to reach him. */
export function SiteFooter() {
  return (
    <footer className={`${styles.wrap} ${styles.footer}`}>
      <p>
        roadrunner.town is a small project built in Catalina by Nicholas De Leon. You can reach him by{' '}
        <a href={`mailto:${EMAIL}`}>email</a> or on{' '}
        <a href={LINKEDIN} target="_blank" rel="noopener noreferrer">
          LinkedIn
        </a>
        .
      </p>
      <nav className={styles.footerLinks} aria-label="About and policies">
        <Link to="/about">About</Link>
        <Link to="/privacy">Privacy</Link>
        <Link to="/guidelines">Guidelines</Link>
        <Link to="/terms">Terms</Link>
      </nav>
    </footer>
  );
}

export const CONTACT = { email: EMAIL, linkedin: LINKEDIN };
